<template>
    <div class="warp">
      <!-- 面包屑 -->
      <breadcrumb :back="true" :crubList="[{name:'债权融资管理'},{name:'融资租赁申请列表',goback:true},{name:'融资租赁申请明细'}]" :title="'融资租赁申请明细'"/>
      <!-- 主体内容 -->
      <!-- 用户明细 -->
      <div class="box">
        <el-card class="basic box_card" header="提交信息" shadow="never">
          <el-row>
            <el-col :span="8">
              <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{tableDetail.applicant}}</div>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{tableDetail.contactPhone}}</div>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{tableDetail.applyCompany}}</div>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{tableDetail.dealWithRemark}}</div>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="attachment" v-if="tableDetail.fileList&&tableDetail.fileList.length>0">
                            <div class="name">附件：</div>
                            <ul class="content">
                                 <li v-for="(item,index) in tableDetail.fileList" :key="index">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{tableDetail.createTime}}</div>
                        </div>
            </el-col>

          </el-row>
        </el-card>
        <el-card class="basic box_card mt16" header="申请结果信息" shadow="never">
          <el-row>
            <el-col :span="8">
             <div class="child">
                            <div class="name">申请结果：</div>
                            <div class="content">{{tableDetail.checkStatusValue}}</div>
                        </div>
            </el-col>
            
            <el-col :span="8">
              <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{tableDetail.modifyUserName}}</div>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{tableDetail.updateTime}}</div>
                        </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
             <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{tableDetail.applyRemark}}</div>
                        </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
  components: {
    breadcrumb
  },
  data() {
    return {
      id: '', //详情id
      tableDetail:{
                applicant:"",//申请人姓名：
                contactPhone:"",//联系手机号：
                applyCompany:"",//公司全称：
                dealWithRemark:"",//说明：
                fileList:[],//附件
                createTime:"",//提交时间：
                checkStatusValue:"",//申请结果：
                applyRemark:"",//申请说明：
                modifyUserName:"",//更新账号：
                updateTime:"",//更新时间：
            }
    }
  },
  methods: {
    //获取数据
    async getData() {
      const { code, data, msg } = await this.$axiosc.get('backstage/financial/leasing/apply/details/'+this.id)
      if (code == 200) {
        this.tableDetail = data
      } else {
        this.$alert(msg)
      }
    },
  },
  created() {
    this.id = this.$route.query.id
  },
  mounted() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box {
  // margin-top: 20px;
  height: calc(100% - 40px);
  overflow-x: hidden;
  overflow-y: auto;
  &_card {
    border: none;
    &::v-deep {
      .el-card__header {
        font-size: 16px;
        color: #262626;
        padding: 14px 22px !important;
        border-bottom-color: #e5e5e5;
      }
      .el-card__body {
        padding: 24px 25px !important;
      }
    }
  }
}
.basic {
  color: $font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col {
    margin: 10px 0;
  }
  .child {
    color: #595959;
  }
}
.main {
  background: transparent !important;
  padding: 0 !important;
}
</style>
